/**
 * Базовый ответ сервера.
 */
export class ServerResponse {
  /**Результат запроса (ok, error) */
  public result: string = "";
  /**Сообщение */
  public message: string = "";
  /**Данные */
  public data: any = null;

  /**
   * Конструктор с загрузкой данных c сервера.
   */
  constructor(result: string = "", message: string = "", data: any = null) {
    this.result = result;
    this.message = message;
    this.data = data;
  }

  /** Ошибка 401 */
  public static error401(): ServerResponse {
    return new ServerResponse("error", "401", "Session timeout.");
  }

  /** Ошибка 500 */
  public static error500(): ServerResponse {
    return new ServerResponse("error", "500", "Server error.");
  }
}
